import type { LayerTypeDto } from "@farm/data/dto/layer-type.dto";
import { LayerTypeDtoSchema } from "@farm/data/dto/layer-type.dto";
import { LayerType } from "@farm/domain/models/layer-type.model";
import { injectable } from "inversify";

@injectable()
export class LayerTypeMapper {
    mapList(responseDto: LayerTypeDto): LayerType[] {
        const parsed = LayerTypeDtoSchema.safeParse(responseDto);

        if (!parsed.success) {
            console.error(
                "Error parsing layer types response:",
                parsed.error.issues,
            );
            return [];
        }

        return parsed.data.layers.mapNotNull((layerDto) => {
            const result = LayerType.createWithRecovery({
                code: layerDto.code,
                name: layerDto.name,
                source: layerDto.source,
                legend: layerDto.legend
                    ? {
                          description: layerDto.legend.description,
                          unit: layerDto.legend.unit,
                          min: layerDto.legend.min,
                          max: layerDto.legend.max,
                          colorRamp: layerDto.legend.color_ramp,
                      }
                    : undefined,
            });

            return result.match(
                (layerType) => layerType,
                (error) => {
                    if (!error.recuperable) {
                        console.error(
                            "Non-recoverable error mapping layer type:",
                            error,
                        );
                    }
                    return null;
                },
            );
        });
    }
}
